import { EstacionPopup } from './estacion-popup';
import { PopupInfoItem } from './entity-popup.interface';

/**
 * Popup para estaciones de lisímetro.
 * Muestra datos de conductividad eléctrica.
 */
export class PuntoLisimetroPopup extends EstacionPopup {
  getBadgeText(): string {
    return `Estación Lisímetro de ${this.entity.provider} (Id ${this.entity.provider_id})`;
  }

  getInfoItems(): PopupInfoItem[] {
    return [
      this.createSensorItem(
        this.entity.ec,
        'Conductividad eléctrica',
        'water_ec',
        'mS/cm'
      ),
    ];
  }
}
